import { ACTIONS } from "app/store/actions"
import { IAppConfirmMessage, IAppMessage, IAppOverlayMessage } from "message/model"
import { Action } from "redux"

export interface IMessageActionAddMessage extends Action {
  message: IAppMessage
}

export interface IMessageActionDeleteMessage extends Action {
  messageId: string
}

export interface IMessageActionSetConfirmMessage extends Action {
  confirmMessage: IAppConfirmMessage | undefined
}

export interface IMessageActionSetInputMessageVisibility extends Action {
  isVisible: boolean
}

export interface IMessageActionAddOverlayMessage extends Action {
  type: ACTIONS.APP_MESSAGE_ADD_OVERLAY_MESSAGE
  message: IAppOverlayMessage
}

export interface IMessageActionDeleteOverlayMessages extends Action {
  type: ACTIONS.APP_MESSAGE_DELETE_OVERLAY_MESSAGES
  messageIds: string[]
}

export const messageActionCreator = {
  addMessage(message: IAppMessage): IMessageActionAddMessage {
    return {
      type: ACTIONS.APP_MESSAGE_ADD_MESSAGE,
      message
    }
  },
  setConfirmMessage(confirmMessage: IAppConfirmMessage | undefined): IMessageActionSetConfirmMessage {
    return {
      type: ACTIONS.APP_MESSAGE_SET_CONFIRM_MESSAGE,
      confirmMessage
    }
  },
  deleteMessage(messageId: string, expired: boolean): IMessageActionDeleteMessage {
    return {
      type: ACTIONS.APP_MESSAGE_DELETE,
      messageId
    }
  },
  addOverlayMessage(message: IAppOverlayMessage): IMessageActionAddOverlayMessage {
    return {
      type: ACTIONS.APP_MESSAGE_ADD_OVERLAY_MESSAGE,
      message
    }
  },
  deleteOverlayMessages(messageIds: string[]): IMessageActionDeleteOverlayMessages {
    return {
      type: ACTIONS.APP_MESSAGE_DELETE_OVERLAY_MESSAGES,
      messageIds
    }
  }
}
